/// <amd-module name="TFS/Admin/Views/OrganizationOverview/Constants/Constants" />
export namespace OrganizationDataProvidersContributions {
    export const DelayLoadDataProviderId = "ms.vss-admin-web.organization-admin-overview-delay-load-data-provider";
    export const EditDataProviderId = "ms.vss-admin-web.organization-admin-overview-data-provider";
    export const DeleteTokenDataProviderId = "ms.vss-admin-web.organization-admin-overview-token-data-provider";
}

export namespace OrganizationServiceInstanceTypes {
    export const ServiceInstanceTypeAex = "00000041-0000-8888-8000-000000000000";
}

export namespace ConstantNumbers {
    export const ProgressPollInterval = 500;
}

export namespace FeatureConstants {
    export const EditableOrganizationAvatar = "VisualStudio.Services.AdminEngagement.OrganizationOverview.EditableOrganizationAvatar";
}
